import {
  Button,
  Flex,
  FormControl,
  FormLabel,
  Select,
  Box,
  Icon,
  Tooltip,
  useColorModeValue,
} from "@chakra-ui/react";
import styled from "@emotion/styled";
import React from "react";
import { MdModeEdit, MdKeyboardArrowDown } from "react-icons/md";
import { FaPlug } from "react-icons/fa";
import { useRecoilValue } from "recoil";

import { activeConnectorState } from "atoms/activeConnectorState";
import { loggedInUserState } from "atoms/loggedInUserState";
import { accessLevels } from "utils/accessLevels";
import RoleBasedRender from "components/wrappers/roleBasedRender";
import { onlyAdmins } from "utils/accessLevels";

// Custom styled components for glass morphism effect
const GlassMorphismSelect = styled(Select)`
  backdrop-filter: blur(6px);
  background: rgba(255, 255, 255, 0.7);
  transition: all 0.3s ease;
  border-radius: 12px;
  border: 1px solid rgba(35, 169, 121, 0.25);
  cursor: pointer;
  z-index: 10;

  &:hover,
  &:focus {
    border-color: #23A979;
    box-shadow: 0 4px 20px rgba(35, 169, 121, 0.25);
  }
`;

const SelectEditConnector = ({ connectorHandler, options, editHandler }) => {
  const loggedInUser = useRecoilValue(loggedInUserState);
  const role = loggedInUser?.role;
  const canEdit = accessLevels[role]?.accessLevel <= 2;
  const activeConnector = useRecoilValue(activeConnectorState);

  const labelColor = useColorModeValue("gray.700", "gray.200");
  const iconColor = useColorModeValue("#23A979", "#ff9966");

  return (
    <Flex
      flexDirection={{
        base: "column",
        md: "row",
      }}
      justifyContent="flex-start"
      alignItems={{
        base: "flex-start",
        md: "flex-end",
      }}
      gap={6}
      width="100%"
    >
      <FormControl
        width={{
          base: "100%",
          md: "300px",
        }}
      >
        <Flex align="center" mb={2}>
          <Icon as={FaPlug} color={iconColor} mr={2} boxSize={{ base: 4, md: 5 }} />
          <FormLabel m={0} fontWeight={600} color={labelColor} fontSize={{ base: "sm", md: "md" }}>
            Select Connector
          </FormLabel>
        </Flex>

        <GlassMorphismSelect
          onChange={(e) => connectorHandler(e.target.value)}
          value={activeConnector?.EvseSerialId || ""}
          name="Connector"
          isDisabled={!canEdit}
          icon={<MdKeyboardArrowDown color={iconColor} />}
          height={{ base: "40px", md: "45px" }}
          fontSize={{ base: "sm", md: "md" }}
          variant="filled"
          _focus={{
            borderColor: "brand.500",
            boxShadow: "0 0 0 1px #23A979",
          }}
          zIndex={10}
        >
          {options}
        </GlassMorphismSelect>
      </FormControl>

      <RoleBasedRender roles={onlyAdmins}>
        <Tooltip
          hasArrow
          label="Edit connector settings"
          placement="top"
          bg="brand.500"
          color="white"
        >
          <Button
            minW={{ base: "full", md: 40 }}
            w={{ base: "100%", md: "auto" }}
            leftIcon={<MdModeEdit />}
            bg="brand.500"
            color="white"
            variant="solid"
            borderRadius="md"
            onClick={() => editHandler(activeConnector.Id)}
            isDisabled={!canEdit}
            _hover={{
              // transform: "translateY(-2px)",
              boxShadow: "0 8px 16px rgba(35, 169, 121, 0.3)",
            }}
            _active={{
              transform: "translateY(0)",
              boxShadow: "0 4px 8px rgba(35, 169, 121, 0.3)",
            }}
            transition="all 0.3s ease"
            height={{ base: "40px", md: "45px" }}
            fontSize={{ base: "sm", md: "md" }}
          >
            Edit Connector
          </Button>
        </Tooltip>
      </RoleBasedRender>
    </Flex>
  );
};

export default SelectEditConnector;
